import { Map } from "lucide-react";
import SectionForm from "./SectionForm";

export default function LevelRegionSelector({
    title,
    items,
    value,
    onChange,
    error,
    dataField,
}) {
    return (
        <SectionForm
            data-field={dataField}
            icon={<Map className="w-5 h-5" />}
            title={title}
            color="blue"
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {items.map((item) => {
                    const selected = value === item.value;
                    const disabled = item.status === "CLOSED";

                    return (
                        <div
                            key={item.value}
                            onClick={() => {
                                if (disabled) return;
                                onChange(item.value);
                            }}
                            className={`rounded-xl border p-4 transition-all relative ${disabled
                                    ? "border-gray-200 bg-gray-50 opacity-70 cursor-not-allowed"
                                    : selected
                                        ? "cursor-pointer border-blue-500 bg-blue-50 ring-2 ring-blue-200"
                                        : "cursor-pointer border-gray-200 hover:border-blue-300 hover:bg-gray-50"
                                }
        `}
                        >
                            <div className="flex items-start justify-between gap-3">
                                <div className="flex-1">
                                    <div className="flex flex-wrap items-center gap-2">
                                        <h3 className="font-semibold text-sm text-gray-900">
                                            {item.title}
                                        </h3>

                                        <span
                                            className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${disabled
                                                    ? "bg-red-100 text-red-700"
                                                    : "bg-green-100 text-green-700"
                                                }`}
                                        >
                                            {disabled ? "Closed" : "Open"}
                                        </span>
                                    </div>

                                    {disabled && (
                                        <p className="text-[11px] text-red-500 mt-2">
                                            Tidak tersedia untuk jenjang pendidikan
                                            yang dipilih.
                                        </p>
                                    )}
                                </div>

                                {selected && !disabled && (
                                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 text-white text-xs shrink-0">
                                        ✓
                                    </div>
                                )}

                                {disabled && (
                                    <div className="flex items-center justify-center w-7 h-7 rounded-full bg-gray-200 text-gray-500 shrink-0">
                                        🔒
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            {error}
        </SectionForm>
    );
}